import Vue from 'vue'
import Vuex from 'vuex'
import { BrowseCoordActions, TopicHotListModuleAuthActions, CommunicationActions, UserActions, RereshActions, TabBarActions, DynamicTabBarActions, MessageActions, RouterActions, TarBarModuleAuthActions, CenterModuleAuthActions, HomeModuleAuthActions, DynamicModuleAuthActions, MakeComplainsModuleAuthActions, RefiningModuleAuthActions, CalendarModuleAuthActions } from './actions'
import { BrowseCoordGetters, HotTopicListGetters, CommunicationGetters, UserGetters, RefreshGetters, TabBarGetters, DynamicTabBarGetters, MessageGetters, RouterGetters, TarBarModuleAuthGetters, CenterModuleAuthGetters, HomeModuleAuthGetters, DynamicModuleAuthGetters, MakeComplainsModuleAuthGetters, RefiningModuleAuthGetters, CalendarModuleAuthGetters } from './getter'
import { BrowseCoordMutations, HotTopicListMutations, CommunicationMutations, UserMutations, RefeshMutations, TabBarMutations, DynamicTabBarMutations, MessageMutations, RouterMutations, TarBarModuleAuthMutations, CenterModuleAuthMutations, HomeModuleAuthMutations, DynamicModuleAuthMutations, MakeComplainsModuleAuthMutations, RefiningModuleAuthMutations, CalendarModuleAuthMutations } from './mutations'
import { BrowseCoordState, TopicModuleHotTopicState, CommunicationState, UserState, RefreshState, TabBarState, DynamicTabBarState, MessageState, RouterState, TabrbarModuleAuthState, CenterModuleAuthState, HomeModuleAuthState, DynamicModuleAuthState, MakeComplainsModuleAuthState, RefiningModuleAuthState, CalendarModuleAuthState } from './state'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    communication: {
      namespaced: true,
      state: CommunicationState,
      actions: CommunicationActions,
      mutations: CommunicationMutations,
      getters: CommunicationGetters
    },
    user: {
      namespaced: true,
      state: UserState,
      actions: UserActions,
      mutations: UserMutations,
      getters: UserGetters
    },
    refresh: {
      namespaced: true,
      state: RefreshState,
      actions: RereshActions,
      mutations: RefeshMutations,
      getters: RefreshGetters
    },
    tabbar: {
      namespaced: true,
      state: TabBarState,
      actions: TabBarActions,
      mutations: TabBarMutations,
      getters: TabBarGetters
    },
    dynamicTabbar: {
      namespaced: true,
      state: DynamicTabBarState,
      actions: DynamicTabBarActions,
      mutations: DynamicTabBarMutations,
      getters: DynamicTabBarGetters
    },
    message: {
      namespaced: true,
      state: MessageState,
      actions: MessageActions,
      mutations: MessageMutations,
      getters: MessageGetters
    },
    router: {
      namespaced: true,
      state: RouterState,
      actions: RouterActions,
      mutations: RouterMutations,
      getters: RouterGetters
    },
    tarbarAuth: {
      namespaced: true,
      state: TabrbarModuleAuthState,
      actions: TarBarModuleAuthActions,
      mutations: TarBarModuleAuthMutations,
      getters: TarBarModuleAuthGetters
    },
    centerAuth: {
      namespaced: true,
      state: CenterModuleAuthState,
      actions: CenterModuleAuthActions,
      mutations: CenterModuleAuthMutations,
      getters: CenterModuleAuthGetters
    },
    homeAuth: {
      namespaced: true,
      state: HomeModuleAuthState,
      actions: HomeModuleAuthActions,
      mutations: HomeModuleAuthMutations,
      getters: HomeModuleAuthGetters
    },
    dynamicAuth: {
      namespaced: true,
      state: DynamicModuleAuthState,
      actions: DynamicModuleAuthActions,
      mutations: DynamicModuleAuthMutations,
      getters: DynamicModuleAuthGetters
    },
    messageAuth: {
      namespaced: true,
      state: MakeComplainsModuleAuthState,
      actions: MakeComplainsModuleAuthActions,
      mutations: MakeComplainsModuleAuthMutations,
      getters: MakeComplainsModuleAuthGetters
    },
    refiningAuth: {
      namespaced: true,
      state: RefiningModuleAuthState,
      actions: RefiningModuleAuthActions,
      mutations: RefiningModuleAuthMutations,
      getters: RefiningModuleAuthGetters
    },
    calendarAuth: {
      namespaced: true,
      state: CalendarModuleAuthState,
      actions: CalendarModuleAuthActions,
      mutations: CalendarModuleAuthMutations,
      getters: CalendarModuleAuthGetters
    },
    TopicList: {
      namespaced: true,
      state: TopicModuleHotTopicState,
      mutations: HotTopicListMutations,
      actions: TopicHotListModuleAuthActions,
      getters: HotTopicListGetters
    },
    BrowseCoord: {
      namespaced: true,
      state: BrowseCoordState,
      mutations: BrowseCoordMutations,
      getters: BrowseCoordGetters,
      actions: BrowseCoordActions
    }
  }
})
